import { useState } from 'react';

import { useEffectOnce } from 'usehooks-ts';

import { apiGetCheckoutData } from '../constants';
import useFetch from './useFetch';
import useReadCartMissingOrder from './useReadCartMissingOrder';
import useReadLoggedUser from './useReadLoggedUser';
import { PAYMENT_WIDGET_METHOD } from './useReadPaymentMethods';

const useFetchCheckoutData = cartId => {
  const loggedUser = useReadLoggedUser();

  const [fetchUrl, setFetchUrl] = useState(null);
  const { data, status } = useFetch(fetchUrl);
  useReadCartMissingOrder(data);

  useEffectOnce(() => {
    if (cartId == null) return;
    // for the initial request when connected we send nothing (no payment), when disconnected we'll get the widget fee
    setFetchUrl(apiGetCheckoutData(cartId, loggedUser ? '' : PAYMENT_WIDGET_METHOD));
  });

  const getDynamicCheckoutData = paymentMethodObject => {
    // no payment selection for logged users currently
    if (loggedUser == null) return;

    // we do this to prevent the team methods to interfere with our own methods : we only send the value if it's system value
    const valueToSend = paymentMethodObject.is_system_method === true ? paymentMethodObject.value : '';
    setFetchUrl(apiGetCheckoutData(cartId, valueToSend));
  };

  return { checkoutData: data, checkoutDataStatus: status, getDynamicCheckoutData };
};

export default useFetchCheckoutData;
